import { Bar, BarChart, CartesianGrid, XAxis } from 'recharts';

import {
  ChartContainer,
  ChartLegend,
  ChartLegendContent,
  ChartTooltip,
  ChartTooltipContent,
} from '@/components/ui/chart';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { useApp } from '@/context/AppContext';
import { colorsBar, dateFormatter } from '@/components/dashboard/Chart/utils';

export function ChartData() {
  const { usageChart } = useApp();

  if (!usageChart || usageChart.length === 0) {
    return null;
  }

  const chartData = usageChart.map((item) => ({
    date: item.date,
    ...item.eventTypes,
  }));

  const eventTypeKeys = Array.from(
    new Set(usageChart.flatMap((item) => Object.keys(item.eventTypes))),
  );

  const chartConfig = Object.fromEntries(
    eventTypeKeys.map((key, idx) => [
      key,
      { label: key, color: colorsBar[idx % colorsBar.length] },
    ]),
  );

  const totalLogs = chartData.reduce(
    (acc, cur) => acc + eventTypeKeys.reduce((a, key) => a + (cur[key] || 0), 0),
    0,
  );

  return (
    <Card className="flex-1">
      <CardHeader>
        <CardTitle>Dados de Usabilidade</CardTitle>
        <div className="text-muted-foreground text-sm mt-2">
          Últimos {chartData.length} dias | Total de logs: {totalLogs}
        </div>
      </CardHeader>
      <CardContent>
        <ChartContainer config={chartConfig} className="h-[300px] w-full">
          <BarChart accessibilityLayer data={chartData}>
            <CartesianGrid vertical={false} />
            <XAxis
              dataKey="date"
              tickLine={false}
              tickMargin={10}
              axisLine={false}
              angle={-20}
              dy={8}
              tickFormatter={dateFormatter}
            />
            <ChartTooltip content={<ChartTooltipContent />} labelFormatter={dateFormatter} />
            <ChartLegend content={<ChartLegendContent className="mt-4" payload={undefined} />} />
            {eventTypeKeys.map((key) => (
              <Bar
                key={key}
                dataKey={key}
                fill={chartConfig[key]?.color || '#888'}
                radius={[4, 4, 0, 0]}
                isAnimationActive={true}
                animationDuration={800}
              />
            ))}
          </BarChart>
        </ChartContainer>
      </CardContent>
    </Card>
  );
}
